import React, { useState } from 'react'

import { Check } from 'lucide-react'

import { useFocusReturn } from 'Hooks/useFocusReturn'
import { CardBrands, ShopCustomerCard } from 'Types'

import PaymentIcon from 'Components/PaymentIcon'

import { ConfirmAction, DangerButton } from '../../../components/ConfirmAction'

const BRAND_LABEL: Record<CardBrands, string> = {
  [CardBrands.AMERICAN_EXPRESS]: 'Amex',
  [CardBrands.MASTERCARD]: 'Mastercard',
  [CardBrands.VISA]: 'Visa',
}

interface PaymentCardProps {
  card: ShopCustomerCard
  deleting: boolean
  onDelete(id: string): void
  onSetPrimary(id: string): void
}

export const PaymentCard: React.FC<PaymentCardProps> = ({ card, deleting, onDelete, onSetPrimary }) => {
  const [confirm, setConfirm] = useState(false)
  const deleteTriggerRef = useFocusReturn<HTMLButtonElement>(confirm)

  return (
    <article className="user-profile-wallet-card">
      <div className="user-profile-wallet-card__body">
        <div className="user-profile-wallet-card__top">
          {card.primary ? (
            <span className="user-profile-wallet-card__default">
              <Check size={12} strokeWidth={2.4} />
              Default
            </span>
          ) : null}
          <span className="user-profile-wallet-card__brand">
            <PaymentIcon aria-hidden height={20} type={card.cardBrand.toLowerCase()} width={28} />
          </span>
        </div>
        <p className="user-profile-wallet-card__number">•••• {card.last4}</p>
        <div className="user-profile-wallet-card__bottom">
          <span className="user-profile-wallet-card__name">{card.cardholderName || 'Cardholder'}</span>
          <span>
            {BRAND_LABEL[card.cardBrand]} · {card.expMonth}/{card.expYear}
          </span>
        </div>
      </div>
      <div className="user-profile-wallet-card__footer">
        {confirm ? (
          <ConfirmAction
            confirmLabel="Remove"
            prompt="Remove this card?"
            onCancel={() => setConfirm(false)}
            onConfirm={() => {
              onDelete(card.id)
              setConfirm(false)
            }}
          />
        ) : card.primary ? null : (
          <>
            <button className="user-profile-link-button" type="button" onClick={() => onSetPrimary(card.id)}>
              Set as default
            </button>
            <DangerButton ref={deleteTriggerRef} disabled={deleting} onClick={() => setConfirm(true)}>
              Delete
            </DangerButton>
          </>
        )}
      </div>
    </article>
  )
}
